// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Nius","largestCol":"styles_largestCol__yIhVV","smallestCol":"styles_smallestCol__3mJfZ"};